<template>
    <div class="w-full overflow-x-auto">
        <table v-loading="loading" class="w-full border border-gray-300 border-collapse min-w-[800px]">
            <thead>
                <tr class="border-b border-gray-300">
                    <th class="px-4 py-2 text-left">Consolidation ID</th>
                    <th class="px-4 py-2 text-left">Consolidation</th>
                    <th class="px-4 py-2 text-left">Shipment Count</th>
                    <th class="px-4 py-2"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="border-b border-gray-300" v-for="consolidation in consolidations" :key="consolidation.id">
                    <td class="px-4 py-2.5">{{ consolidation && consolidation.consolidationReference ?
                        consolidation.consolidationReference : 'N/A' }}</td>
                    <td class="px-4 py-2.5">{{ currentLocation && currentLocation.location ? currentLocation.location.state : "--" }} to {{ consolidation && consolidation.destinationTerminal &&
                        consolidation.destinationTerminal.state ? consolidation.destinationTerminal.state : '--' }}</td>
                    <td class="px-4 py-2.5">{{ consolidation && consolidation.shippings ? consolidation.shippings.length
                        : '0' }} shipment(s)</td>
                    <td class="px-4 py-2"><button class=" text-primary-green"
                        @click="$router.push(`/operations/manifest-new/${consolidation.id}`)"
                        >View Manifest</button></td>
                </tr>
            </tbody>
        </table>
        <ConsolidationSuccess :showModal="showSuccessConsolidation" @close-modal="showSuccessConsolidation = false" />
    </div>
</template>

<script>
import ConsolidationSuccess from "../modal/confirm-consolidation.vue"
export default {
    data() {
        return {
            showSuccessConsolidation: false,
            consolidations: [],
            loading: false
        }
    },
    activated() {
        this.getALlConsolidation();
    },
    components: {
        ConsolidationSuccess
    },
    computed: {
        currentLocation() {
            return this.$store.getters.currentLocation;
        },
    },
    methods: {
        async getALlConsolidation() {
            this.loading = true
            try {
                let response = await this.$_newGetConsolidations();
                console.log("response from consolidation", response?.data?.data?.consolidation);
                this.consolidations = response?.data?.data?.consolidation
            } catch (error) {
                // code here
            }
            this.loading = false
        }
    },
}
</script>

<style lang="scss" scoped></style>